import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { signUpVolunteerEvent } from '../functions/chatRooms';
import {
  createVolunteerEvent,
  deleteVolunteerEvent,
  editVolunteerEvent,
  getVolunteerEventById,
  getVolunteerEvents
} from '../functions/volunteer';
import { VolunteerEventParams } from '../models/volunteerModels';

export const useGetVolunteerEventById = ({ id }: { id: string }) =>
  useQuery({
    queryKey: ['get-volunteer-event-by-id', id],
    queryFn: () => getVolunteerEventById({ id }),
    enabled: !!id
  });

export const useGetVolunteerEvents = (params: VolunteerEventParams) =>
  useInfiniteQuery({
    queryKey: [
      'get-volunteer-events',
      params.n,
      params.limit,
      params.npo,
      params.latitude,
      params.longitude,
      params.lastDistance
    ],
    queryFn: getVolunteerEvents,
    initialPageParam: params.n?.toString(),
    getNextPageParam: (lastPage) => {
      if (lastPage.lastN && lastPage.lastDistance) {
        return JSON.stringify({ n: lastPage.lastN, lastDistance: lastPage.lastDistance });
      } else if (lastPage.lastN) {
        return lastPage.lastN;
      } else {
        return null;
      }
    }
  });

export const useSignUpVolunteerEvent = () =>
  useMutation({
    mutationKey: ['sign-up-volunteer-event'],
    mutationFn: signUpVolunteerEvent
  });

export const useCreateVolunteerEvent = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['create-volunteer-event'],
    mutationFn: createVolunteerEvent,
    onError: (e: any) => {
      showError({});
      console.error('Error creating volunteer event', e);
    }
  });
};

export const useEditVolunteerEvent = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['edit-volunteer-event'],
    mutationFn: editVolunteerEvent,
    onError: (e: any) => {
      showError({});
      console.error('Error editing volunteer event', e);
    }
  });
};

export const useDeleteVolunteerEvent = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['delete-volunteer-event'],
    mutationFn: deleteVolunteerEvent,
    onError: (e: any) => {
      showError({});
      console.error('Error deleting volunteer event', e);
    }
  });
};
